import {useEffect, useState} from 'react';
import Swal from 'sweetalert2';
import {Button} from 'reactstrap';
import download from 'downloadjs';

import * as apiClient from 'src/api/dependency';
import {NodeTree, FlatGraph, colorTag, isSearchNode} from 'src/state/dependency2';
import {GraphView} from 'src/components';
import {getImpactAnalysisCsv} from 'src/api/dependency';

import './styles.css';

const ImpactAnalysisTab = ({nodeData}) => {
  const [flatGraph, setFlatGraph] = useState(new FlatGraph(new NodeTree()));

  const exportReport = async () => {
    const res = await getImpactAnalysisCsv(nodeData.id);
    if (res) {
      download(
          res,
          'CodeLogic Impact Analysis.csv',
          'text/csv;charset=UTF-8',
      );
    } else {
      await Swal.fire('Unable to download CSV', 'Error retrieving CSV from the backend.  Please try again in 30 seconds.', 'error');
    }
  };

  useEffect(() => {
    if (nodeData) {
      analyzeImpact(nodeData);
    }
  }, [nodeData]);

  const analyzeImpact = async (node) => {
    const nodeResults = await apiClient.getImpact(node.id);
    let results : any = {};
    if (nodeResults.data.status === 'success') {
      results = nodeResults.data.data;
    } else {
      if (nodeResults.status === 404) {
        Swal.fire({
          title: 'No dependency impact found',
          text: 'This may occur when no incoming relationships exist to the item.',
        });
      } else {
        const message = nodeResults.data.error ?
          nodeResults.data.error.message :
          'unknown server error';

        Swal.fire({
          title: 'An error occurred calculating impact.',
          text: message,
        });
      }

      results = {
        id: node.id,
        name: node.name,
        type: node.type,
        containedNodes: [],
        referencedNodes: [],
        nodes: [],
        relationships: [],
      };
    }

    results.nodes.map((n) => {
      n.category = 'impact';
      n.metadata = {};
      n.metadata.type = n.primaryLabel;
      n.metadata.identity = n.identity;
      n.text = n.name;
      n.shortName = n.properties?.shortName;
      n.color = colorTag(n.primaryLabel, undefined, isSearchNode(n.primaryLabel)).color;
      n.key = n.id;
    });

    results.relationships.map((r) => {
      r.from = r.startId;
      r.to = r.endId;
      r.key = r.id;
      r.color = colorTag('*' + r.type, 'edge').color;
    });

    const flatGraph = new FlatGraph(new NodeTree());

    flatGraph.nodes = results.nodes;
    flatGraph.edges = results.relationships;

    setFlatGraph(flatGraph);
  };

  return flatGraph.nodes.length > 0 ? (
          <div className="ImpactAnalysisTab">
            <Button
              color="primary"
              onClick={exportReport}
            >
              Export
            </Button>
            <GraphView
              impact={true}
              setCurrNode={() => {/* no op */}}
              reset={true}
              toggleReset={() => {/* no op */}}
              flatGraph={flatGraph}
              forceLoad={0}
            />
          </div>
      ) : <NoData />;
};

const NoData = () => <span>No impact analysis data</span>;


export default ImpactAnalysisTab;
